module.exports = __webpack_public_path__ + "img/SMT_39_Mr_James_Koh_Kok_Seng.03eac9e5.jpg";